import AccountListItem from "@components/AccountListItem/AccountListItem";
import AddButton from "@components/AddButton/AddButton";
import { BottomSheetInputAmount } from "@components/BottomSheetInputAmount/BottomSheetInputAmount";
import EmptyList from "@components/EmptyList/EmptyList";
import Header from "@components/Header/Header";
import MenuItem from "@components/MenuItem/MenuItem";
import QRButton from "@components/QRButton/QRButton";
import SearchBar from "@components/SearchBar/SearchBar";
import SectionLabel from "@components/SectionLabel/SectionLabel";
import { filterBySearchQuery, truncateAddress } from "@lib/utils";
import { GRAYSCALE_400, PALE_BLUE, WHITE } from "@styles/colors";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
    Container,
    BodyContainer,
    FixedContentContainer,
    SearchAndQRContainer,
    AddressListContainer,
    EmptyListContainer,
    EmptyListText,
    AddressList,
    AddressItemContainer,
    BottomButtonContainer,
    AlertTextContainer,
    AlertBoldText
} from "./P2PTransfer.styles";
import useManageAddressBook from "@hooks/useManageAddressBook";
import LoadingModal from "@components/LoadingModal/LoadingModal";
import { setHeaderColor } from "@lib/telegram";
import AlertBox from "@components/AlertBox/AlertBox";

const P2PTransfer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { addresses, isLoading } = useManageAddressBook()
    const [isOpen, setIsOpen] = useState(false);
    const { address } = location.state || {};
    const [destination, setDestination] = useState({
        address: address || '',
        name: ''
    });

    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        if (address) {
            setIsOpen(true)
        }
    }, [address])

    const handleAddNew = () => {
        navigate('/manage-address?mode=add&source=p2p-transfer')
    };

    useEffect(() => {
        setHeaderColor(WHITE)
    }, [])

    return (
        <Container>
            <Header title={t('p2p.transfer.header')} showBackButton onBackClick={() => navigate('/transfer')} />
            <LoadingModal visible={isLoading} />
            <BodyContainer>
                <FixedContentContainer>
                    <SearchAndQRContainer>
                        <SearchBar value={searchQuery} onChange={(value) => setSearchQuery(value)} />
                        <QRButton onClick={() => navigate('/qr-scanner', { state: { from: '/p2p-transfer', to: '/p2p-transfer' } })} />
                    </SearchAndQRContainer>
                    <MenuItem
                        title={t('p2p.transfer.oneTimeTransfer.title')}
                        description={t('p2p.transfer.oneTimeTransfer.description')}
                        onClick={() => navigate('/p2p-one-time-transfer')}
                    />

                    <AlertBox>
                        <AlertTextContainer>
                            {t('p2p.transfer.alertText')}
                            <AlertBoldText>
                                {t('p2p.transfer.jidrToken')}
                            </AlertBoldText>
                        </AlertTextContainer>
                    </AlertBox>

                    <SectionLabel>{t('p2p.transfer.addressList')}</SectionLabel>
                </FixedContentContainer>

                <AddressListContainer>
                    {!isLoading && (!addresses || addresses.length === 0) &&
                        <EmptyListContainer>
                            <EmptyList backgroundColor={GRAYSCALE_400}>
                                <EmptyListText>{t('p2p.transfer.emptyList')}</EmptyListText>
                                <AddButton onClick={() => handleAddNew()} $backgroundColor={PALE_BLUE} />
                            </EmptyList>
                        </EmptyListContainer>
                    }
                    {!isLoading && addresses && addresses.length !== 0 &&
                        <AddressList>
                            {filterBySearchQuery(addresses, searchQuery, ['name', 'address']).map((item) => (
                                <AddressItemContainer key={item.address_uuid}>
                                    <AccountListItem
                                        oneLine
                                        name={item.name}
                                        nickname={item.name}
                                        iconUrl=""
                                        profilePicturePlaceholder={item.name}
                                        accountNumber={truncateAddress(item.address, 10, 10)}
                                        provider="J-Wallet"
                                        isValid={true}
                                        onClick={() => {
                                            setIsOpen(true)
                                            setDestination({
                                                address: item.address,
                                                name: item.name
                                            })
                                        }}
                                    />
                                </AddressItemContainer>
                            ))}
                        </AddressList>
                    }
                </AddressListContainer>

                {addresses && addresses.length !== 0 &&
                    <BottomButtonContainer>
                        <AddButton onClick={() => handleAddNew()} $backgroundColor={PALE_BLUE} />
                    </BottomButtonContainer>
                }
            </BodyContainer>
            <BottomSheetInputAmount
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onContinue={(amount) => navigate('/p2p-transfer-confirmation/default', {
                    state: {
                        amount,
                        address: destination.address,
                        name: destination.name
                    }
                })}
            />
        </Container>
    )
}

export default P2PTransfer;